module.exports = "<p>\r\n  alerts works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/alerts/alerts.component.html
// module id = ./src/app/home/alerts/alerts.component.html
// module chunks = main